/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useState,
  useContext,
  createContext,
  ReactNode,
  useReducer,
} from 'react';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import { getHCPCSdiagallowed } from '@mummssoftware/utils/hcpcsUtils';
import { Context } from '../../../context';
import {
  SET_HCPCS_CHOICE,
  SET_HCPCS_DURATION,
  SET_SHOW_HCPCS,
  SET_HCPCS_ERROR,
  DELETE_HCPCS_CHOICE,
  DELETE_ICD_CODE,
  ADD_ICD_CODE,
  ADD_SAVED_ICD_CODE,
  SET_ICD_SECTION,
  SET_HCPCS_CODE_MAP,
  RESET_HCPCS,
  RESET_HCPCS_FOR_RELOAD,
  SHOW_VISIT_LOADER,
  SET_SUBMIT_HCPCS_ERROR,
  DISABLE_HCPCS_MENU,
  RECORD_DATA,
} from '../constants';

// todo type in mumms
type HCPCSContextProviderProps = {
  children: ReactNode;
};

type HCPCSContext = {
  hcpcsDuration: mumms.HCPCSDuration | null;
  hcpcsChoices: mumms.HCPCSCascadeMenuItem[] | any;
  showHCPCS: boolean;
  hcpcsNameSelected: { hcpcsName: string; key: string } | null;
  hcpcsMapping: mumms.HCPCSMapping | null;
  hcpcsError: boolean;
  submithcpcsError: boolean;
  hcpcsPermission: mumms.HCPCSPermission | null;
  icdCodes: mumms.ICDCode | null;
  icdCodeNames: Record<string, string[]>;
  icdSection: Record<string, mumms.HCPCSMenuItem[]>;
  hcpcsCodesMap: Record<string, string[]>;
  showVisitLoader: boolean;
  disabledHCPCSMenu: boolean;
  recordData: boolean;
  dispatchHCPCS?: any;
};

type HCPCSContextState = {
  hcpcsDuration: mumms.HCPCSDuration | null;
  hcpcsChoices: mumms.HCPCSCascadeMenuItem[] | any;
  showHCPCS: boolean;
  hcpcsNameSelected: { hcpcsName: string; key: string } | null;
  hcpcsMapping: mumms.HCPCSMapping | null;
  hcpcsError: boolean;
  icdCodes: mumms.ICDCode | null;
  icdSection: Record<string, mumms.HCPCSMenuItem[]>;
  icdCodeNames: Record<string, string[]>;
  hcpcsCodesMap: Record<string, string[]>;
  showVisitLoader: boolean;
  submithcpcsError: boolean;
  disabledHCPCSMenu: boolean;
  recordData: boolean;
  dispatchHCPCS?: any;
};

const initialState = {
  hcpcsDuration: null,
  hcpcsChoices: [],
  showHCPCS: false,
  hcpcsNameSelected: null,
  hcpcsMapping: null,
  hcpcsError: false,
  icdSection: {},
  icdCodes: null,
  icdCodeNames: {},
  hcpcsCodesMap: {},
  showVisitLoader: false,
  submithcpcsError: false,
  disabledHCPCSMenu: false,
  recordData: false,
};

const initHCPCSContext = {
  hcpcsDuration: null,
  hcpcsChoices: [],
  showHCPCS: false,
  hcpcsNameSelected: null,
  hcpcsMapping: null,
  hcpcsError: false,
  icdCodes: null,
  icdSection: {},
  hcpcsPermission: null,
  icdCodeNames: {},
  hcpcsCodesMap: {},
  showVisitLoader: false,
  submithcpcsError: false,
  disabledHCPCSMenu: false,
  recordData: false,
};

export const HCPCSContextReducer = (
  state: HCPCSContextState,
  action: { type: string; payload: mumms.ComponentName | any },
) => {
  let newState = { ...state };
  switch (action.type) {
    case SET_HCPCS_DURATION:
      if (action.payload) {
        const { key, duration } = action.payload;
        newState.hcpcsDuration = {
          ...(newState.hcpcsDuration || {}),
          [key]: duration,
        };
      }
      break;
    case SET_SHOW_HCPCS:
      newState.showHCPCS = action.payload;
      break;
    case SET_HCPCS_ERROR:
      newState.hcpcsError = action.payload;
      break;
    case SHOW_VISIT_LOADER:
      newState.showVisitLoader = action.payload;
      break;
    case DISABLE_HCPCS_MENU:
      newState.disabledHCPCSMenu = action.payload;
      break;
    case SET_SUBMIT_HCPCS_ERROR:
      newState.submithcpcsError = action.payload;
      break;
    case RECORD_DATA:
      newState.recordData = action.payload;
      break;
    case SET_HCPCS_CODE_MAP:
      if (action.payload) {
        const choice = action.payload;
        const { key, codes } = choice;
        newState.hcpcsCodesMap = {
          ...newState.hcpcsCodesMap,
          [key]: codes,
        };
      }
      break;
    case SET_ICD_SECTION:
      if (action.payload) {
        const choice = action.payload;
        const { key, codes } = choice;
        newState.icdSection = {
          ...newState.icdSection,
          [key]: codes,
        };
      }
      break;
    case ADD_ICD_CODE:
      if (action.payload) {
        const choice = action.payload;
        const { key, icdCode } = choice;
        const prevCodesForKey =
          (newState.icdCodes && newState.icdCodes[key]) || {};
        const nextCount = (prevCodesForKey[icdCode] || 0) + 1;
        newState.icdCodes = {
          ...(newState.icdCodes || {}),
          [key]: {
            ...prevCodesForKey,
            [icdCode]: nextCount,
          },
        };

        newState.icdCodeNames = {
          ...newState.icdCodeNames,
          [key]: newState.icdCodeNames[key]
            ? [...newState.icdCodeNames[key], icdCode]
            : [icdCode],
        };
      }
      break;
    case ADD_SAVED_ICD_CODE:
      if (action.payload) {
        const choice = action.payload;
        const { key, icdCode } = choice;
        const prevCodesForKey =
          (newState.icdCodes && newState.icdCodes[key]) || {};
        newState.icdCodes = {
          ...(newState.icdCodes || {}),
          [key]: {
            ...prevCodesForKey,
            [icdCode]: 1,
          },
        };

        const prevNames = newState.icdCodeNames[key];
        if (!prevNames) {
          newState.icdCodeNames = {
            ...newState.icdCodeNames,
            [key]: [icdCode],
          };
        } else if (!prevNames.includes(icdCode)) {
          newState.icdCodeNames = {
            ...newState.icdCodeNames,
            [key]: [...prevNames, icdCode],
          };
        }
      }
      break;
    case DELETE_ICD_CODE:
      if (action.payload) {
        const choice = action.payload;
        const { key, icdCode, index } = choice;
        if (newState.icdCodes) {
          if (newState.icdCodes[key] && newState.icdCodes[key][icdCode]) {
            if (newState.icdCodes[key][icdCode] === 1) {
              delete newState.icdCodes[key][icdCode];
            } else {
              newState.icdCodes[key][icdCode] = --newState.icdCodes[key][
                icdCode
              ];
            }
          } else if (newState.icdCodes[key]) {
            // do nothing
          } else if (newState.icdCodes) {
            // do nothing
          }
        }
        if (Object.keys(newState.icdSection).length) {
          const array = newState.icdSection[key];
          const section = [...array];
          const updatedSection = section.map(
            (x: mumms.HCPCSMenuItem, i: number) => {
              if (i === index) {
                return { ...x, hide: true };
              }
              return x;
            },
          );
          newState.icdSection[key] = updatedSection;
        }
        // remove from icdCodeNames
        if (newState.icdCodeNames[key]) {
          const arr = newState.icdCodeNames[key];
          const indexDup = arr.findIndex((x) => x === icdCode);
          const newArr = arr.filter((x: any, i: number) => i !== indexDup);
          newState.icdCodeNames[key] = newArr;
        }
      }
      break;
    case DELETE_HCPCS_CHOICE:
      {
        const key = action.payload;
        if (newState.hcpcsMapping) {
          delete newState.hcpcsMapping[key];
          newState.hcpcsChoices = Object.values(newState.hcpcsMapping);
        }
        if (newState.hcpcsDuration) {
          delete newState.hcpcsDuration[key];
        }
        if (newState.icdSection && newState.icdCodes && newState.icdCodeNames) {
          delete newState.icdSection[key];
          delete newState.icdCodes[key];
          delete newState.icdCodeNames[key];
        }
        if (newState.hcpcsCodesMap[key]) {
          delete newState.hcpcsCodesMap[key];
        }
        if (newState.hcpcsMapping) {
          const { hcpcsMapping } = newState;
          // error only if not HCPCS left
          const hcpcsKeys = hcpcsMapping && Object.keys(hcpcsMapping);
          if (hcpcsKeys && hcpcsKeys.length < 1) {
            newState.hcpcsError = action.payload;
          }
        }
        newState.disabledHCPCSMenu = false;
      }
      break;
    case SET_HCPCS_CHOICE:
      // eslint-disable-next-line no-lone-blocks
      {
        if (action.payload) {
          const choice = action.payload;
          const hcpcsName = choice.parentName
            ? `${choice.parentName} - ${choice.name}`
            : `${choice.name}`;
          const { key } = choice;
          newState.hcpcsNameSelected = { hcpcsName, key };
          newState.hcpcsError = false;
          if (newState.hcpcsMapping) {
            newState.hcpcsMapping[key] = { ...choice, visible: true };
          } else {
            newState.hcpcsMapping = {};
            newState.hcpcsMapping[key] = { ...choice, visible: true };
          }
          newState.hcpcsChoices = Object.values(newState.hcpcsMapping);
        }
      }
      break;
    case RESET_HCPCS_FOR_RELOAD:
      // eslint-disable-next-line no-lone-blocks
      {
        newState.hcpcsDuration = null;
        newState.hcpcsChoices = [];
        newState.hcpcsNameSelected = null;
        newState.hcpcsMapping = null;
        newState.hcpcsError = false;
        newState.submithcpcsError = false;
        newState.icdCodes = null;
        newState.icdCodeNames = {};
        newState.icdSection = {};
        newState.hcpcsCodesMap = {};
        newState.disabledHCPCSMenu = false;
        newState.recordData = false;
      }
      break;
    case RESET_HCPCS:
      // eslint-disable-next-line no-lone-blocks
      {
        newState.hcpcsDuration = null;
        newState.hcpcsChoices = [];
        newState.showHCPCS = false;
        newState.hcpcsNameSelected = null;
        newState.hcpcsMapping = null;
        newState.hcpcsError = false;
        newState.submithcpcsError = false;
        newState.icdCodes = null;
        newState.icdCodeNames = {};
        newState.icdSection = {};
        newState.hcpcsCodesMap = {};
        newState.disabledHCPCSMenu = false;
        newState.recordData = false;
      }
      break;
    default:
      newState = state;
      break;
  }

  return newState;
};

export const HCPCSContext = createContext<HCPCSContext>(
  initHCPCSContext as HCPCSContext,
);
export const HCPCSContextProvider = ({
  children,
}: HCPCSContextProviderProps) => {
  const [
    {
      hcpcsDuration,
      hcpcsChoices,
      showHCPCS,
      hcpcsNameSelected,
      hcpcsMapping,
      hcpcsError,
      icdCodes,
      icdSection,
      icdCodeNames,
      hcpcsCodesMap,
      showVisitLoader,
      submithcpcsError,
      disabledHCPCSMenu,
      recordData,
    },
    dispatch,
  ] = useReducer(HCPCSContextReducer, initialState);
  const { keycloak, patient, agency } = useContext(Context);
  const { appVisit } = useContext(GlobalContext);

  const [
    hcpcsPermission,
    setHCPCSPermission,
  ] = useState<mumms.HCPCSPermission | null>(null);

  // getHCPCSdiagsearch(keycloak, agency, 'G30');

  const getHCPCSDiagallowed = async () => {
    if (!hcpcsPermission) {
      if (patient && appVisit) {
        const permissions = await getHCPCSdiagallowed(
          keycloak,
          agency,
          patient?.patientNumber,
          patient?.id,
          appVisit.roleshortname || (appVisit as any).careProviderRole,
          appVisit.effectivedatetime,
        );
        if (
          !(permissions instanceof Response) &&
          !permissions.hint &&
          permissions.length
        ) {
          setHCPCSPermission(permissions[0]);
        }
      }
    }
  };

  useEffect(() => {
    getHCPCSDiagallowed();
  }, [appVisit, patient, hcpcsPermission]);

  useEffect(() => {
    if (hcpcsMapping && !Object.keys(hcpcsMapping).length && submithcpcsError) {
      dispatch({
        type: SET_SUBMIT_HCPCS_ERROR,
        payload: false,
      });
    }
  }, [hcpcsMapping && Object.keys(hcpcsMapping)]);

  return (
    <HCPCSContext.Provider
      value={{
        hcpcsDuration,
        hcpcsChoices,
        showHCPCS,
        hcpcsPermission,
        hcpcsNameSelected,
        hcpcsMapping,
        hcpcsError,
        icdCodes,
        icdSection,
        icdCodeNames,
        hcpcsCodesMap,
        showVisitLoader,
        submithcpcsError,
        disabledHCPCSMenu,
        recordData,
        dispatchHCPCS: dispatch,
      }}
    >
      {children}
    </HCPCSContext.Provider>
  );
};

export default HCPCSContextProvider;
